import React from 'react';
import styled, {type css} from 'styled-components';

import {getSpacing, s4, s15} from 'web-app/styleguide/spacing';
import getStyling from 'web-app/react/whitelabel/logos/print-header-logo';

const StyledIconRenderer = styled.div<{cssBlock: ReturnType<typeof css>}>`
    display: none;

    @media print {
        display: block;
        position: absolute;
        top: ${getSpacing(s4)};
        right: ${getSpacing(s4)};
        height: ${getSpacing(s15)};
        width: ${getSpacing(s15)};

        &:after {
            content: '';
            display: block;
            height: 100%;
            width: 100%;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
        }

        ${props => props.cssBlock};
    }
`;

export default () => {
    const style = React.useMemo(() => {
        return getStyling();
    }, []);

    /**
     * The ID is present to easily allow other views to hide this logo if so desired.
     */
    return <StyledIconRenderer id="printHeader" cssBlock={style} />;
};
